import * as React from 'react';
import withStyles, {
  WithStyles,
  StyleRules,
  ClassNameMap
} from '@material-ui/core/styles/withStyles';
import {Theme} from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import classNames from 'classnames';

const styles = (theme: Theme): StyleRules => ({
  root: {
    textAlign: 'unset',
    paddingTop: 75,
    paddingLeft: 15,
    paddingRight: 15
    //background: "black url(https://static.boydgaming.net/boydgaming/assets/shell/background.jpg) top no-repeat;",
  },
  toolbar: {
    '@media only print': {display: 'none'}
  },
  flex: {
    flex: 1
  },
  appTitle: {
    flex: 1,
    color: '#fff',
    marginTop: 5,
    fontFamily: 'Arial,san-serif,Helvetica,Trebuchet MS'
  },
  drawerList: {
    width: 250
  },
  menuButton: {
    color: "#626262 !important",
    marginLeft: -12,
    marginRight: 20
  },
  logo: {
    marginTop: 0,
    height: 40,
    width: 'auto'
  },
  bottomPadding: {
    height: 60
  },
  // chip: {
  //   margin: theme.spacing.unit
  // },
  homeIcon: {
    marginRight: 10
  },
  homeButton: {
    marginRight: 0,
    marginLeft: "0 !important",
    paddingLeft: 11,
  },
  appBarButton:{}
});

interface Props extends React.HTMLProps<HTMLDivElement> {
  href?: string;
}

type State = {};

class EmptySet extends React.Component<
  Props & WithStyles<keyof typeof styles>,
  State
> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {});
    this.state = {};
  }

  // componentWillReceiveProps(
  //   newProps: Props & WithStyles<keyof typeof styles>
  // ) {}

  goHome = () => {
    window.location.href = '/';
  };

  render() {

    const {classes}: {classes: ClassNameMap} = this.props;

    return (
      <IconButton
        onClick={this.goHome}
        className={classNames(classes.homeButton, classes.menuButton, 'fa fa-home')}
      />
    );
  }
}

export default withStyles(styles)(EmptySet);
